import { Outlet, ScrollRestoration } from 'react-router-dom';
import Header from './Header';

export default function PublicShipmentLayout() {
  return (
    <div className="flex min-h-dvh flex-col bg-gray-98">
      {/* Responsive pass (2026-10-29): each top-level layout carries one — see AppLayout. */}
      <ScrollRestoration />
      <Header />
      <div className="mx-auto mt-8 mb-8 w-full max-w-[1536px] grow px-4 min-[600px]:px-6">
        <Outlet />
      </div>
    </div>
  );
}
